// ----------------------------------------------------------------------

function path(root: string, subLink: string) {
    return `${root}${subLink}`
}

const ROOTS_DASHBOARD = '/dashboard'
const ROOTS_CALL_TRACKING = '/appels'
const ROOTS_WEB_FORMS = '/web-formulaires'
const ROOTS_CONTACTS = '/contacts'
const ROOTS_MAILING = '/mailing'
const ROOTS_NATURAL_REFERENCING = '/referencement-naturel'
const ROOTS_PROFILE = '/profile'
const ROOTS_WORDPRESS_UPDATES = '/mise-a-jours'
const ROOTS_REPORT = '/rapport'
const ROOTS_SUPPORT = '/support'
const ROOTS_LOGOUT = '/logout'
const ROOTS_CONVERSION_CLICK = '/conversion-click'

const ROOTS_AUTH = '/auth'

// ----------------------------------------------------------------------

const PATH_AUTH = {
    login: path(ROOTS_AUTH, '/login'),
    forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
}

const PATH_CALL_TRACKING = {
    root: ROOTS_CALL_TRACKING,
    createAccount: path(ROOTS_CALL_TRACKING, '/creer-compte-calltracking'),
}
const PATH_WEB_FORMS = {
    root: ROOTS_WEB_FORMS,
    form: path(ROOTS_WEB_FORMS, '/form'),
    createAccount: path(ROOTS_WEB_FORMS, '/creer-compte-vos-formulaires'),
}

const PATH_CONTACTS = {
    root: ROOTS_CONTACTS,
    contactEdit: path(ROOTS_CONTACTS, '/modifier-contact'),
}

const PATH_MAILING = {
    root: ROOTS_MAILING,
    home: path(ROOTS_MAILING, '/accueil'),
    createAccount: path(ROOTS_MAILING, '/creer-compte-mailing'),
    campaigns: {
        root: path(ROOTS_MAILING, '/campagnes'),
        favorites: path(ROOTS_MAILING, '/campagnes/favoris'),
        drafts: path(ROOTS_MAILING, '/campagnes/brouillons'),
        scheduled: path(ROOTS_MAILING, '/campagnes/programmees'),
        sent: path(ROOTS_MAILING, '/campagnes/envoyees'),
        Archived: path(ROOTS_MAILING, '/campagnes/archivees'),
    },
    campaign: {
        root: path(ROOTS_MAILING, '/campagne'),
        create: path(ROOTS_MAILING, '/campagne/creer'),
        edit: path(ROOTS_MAILING, '/campagne/editer'),
        show: path(ROOTS_MAILING, '/campagne/apercu'),
        statistics: path(ROOTS_MAILING, '/campagne/statistiques'),
    },
    contacts: {
        root: path(ROOTS_MAILING, '/mailing-contacts'),
        show: path(ROOTS_MAILING, '/mailing-contacts'),
        subscribers: path(ROOTS_MAILING, '/mailing-contacts/abonnes'),
    },
    templates: {
        root: path(ROOTS_MAILING, '/templates'),
        admin: path(ROOTS_MAILING, '/templates/admin'),
        myModels: path(ROOTS_MAILING, '/templates/mes-modeles'),
        create: path(ROOTS_MAILING, '/templates/creer'),
        coder: path(ROOTS_MAILING, '/templates/codeur'),
    },
}

const PATH_NATURAL_REFERENCING = {
    root: ROOTS_NATURAL_REFERENCING,
    createAccount: path(ROOTS_NATURAL_REFERENCING, '/creer-compte-statistiques'),
}

const PATH_PROFILE = {
    root: ROOTS_PROFILE,
    edit: path(ROOTS_PROFILE, '/editer'),
    products: path(ROOTS_PROFILE, '/produits'),
    privacyPolicy: path(ROOTS_PROFILE, '/politique-confidentialite'),
}

const PATH_UPDATE_PLUGINS = {
    root: ROOTS_WORDPRESS_UPDATES,
    createAccount: path(ROOTS_WORDPRESS_UPDATES, '/creer-compte-upgrade-plan'),
}

const PATH_REPORT = {
    root: ROOTS_REPORT,
}

const PATH_SUPPORT = {
    root: ROOTS_SUPPORT,
    ticket: path(ROOTS_SUPPORT, '/ticket'),
    createAccount: path(ROOTS_SUPPORT, '/creer-compte-sav'),
}

const PATH_CONVERSION_CLICK = {
    root: ROOTS_CONVERSION_CLICK,
}

export {
    ROOTS_DASHBOARD,
    ROOTS_AUTH,
    PATH_AUTH,
    ROOTS_LOGOUT,
    PATH_CALL_TRACKING,
    PATH_WEB_FORMS,
    PATH_CONTACTS,
    PATH_MAILING,
    PATH_NATURAL_REFERENCING,
    PATH_PROFILE,
    PATH_UPDATE_PLUGINS,
    PATH_REPORT,
    PATH_SUPPORT,
    PATH_CONVERSION_CLICK,
}


